// @ts-check
import Button from '@gaia/components/Button';
import {Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';

/**
 * @typedef {import('react').MouseEvent<HTMLButtonElement>} ButtonMouseEvent
 * @typedef ConfirmationDialogProps
 * @prop {(event: ButtonMouseEvent) => void} onClose
 * @prop {(event: ButtonMouseEvent) => void} onRemove
 * @prop {boolean} open
 *
 * @param {ConfirmationDialogProps} props
 */
export default function ConfirmationDialog(props) {
    const actions = [
        <Button key={0} appearance='secondary' onClick={props.onClose}>
            Cancel
        </Button>,
        <Button key={1} appearance='destruct' onClick={props.onRemove}>
            DELETE
        </Button>,
    ];

    return (
        <Dialog onClose={props.onClose} open={props.open}>
            <DialogTitle className='dialog-title'>Delete item</DialogTitle>
            <DialogContent>
                <div>Are you sure you want to do this?</div>
            </DialogContent>
            <DialogActions>{actions}</DialogActions>
        </Dialog>
    );
}
